import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';

import { ConfigService } from '../config.service';

@Component({
    host: { 'test-id': 'login-error' },
    selector: 'login-error',
    template: `
    <fw-layout-context
      title="Login Error"
      [description]="data"
      icon="warning-circle"
      iconColor="danger"
    >
      <fw-button (click)="retry()" variant="outline" leftIcon="rotate-refresh" size="large">Retry</fw-button>
    </fw-layout-context>
  `,
    styles: [`
    :host {
      width: 100vw;
      height: 100vh;
      background: var(--page-light);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  `],
    standalone: false,
})
export class LoginErrorComponent {
  private auth0 = inject(Auth0Service);
  private config = inject(ConfigService);
  private router = inject(Router);
  private dialog = inject<DialogRef<LoginErrorComponent>>(DialogRef);
  data? = inject(DIALOG_DATA);


  retry(): void {
    if (!this.config.isAuth0Enabled()) {
      this.router.navigate(['/login']);
      this.dialog.close();
      return;
    }
    // router.url can be '/' when the auth guard has cancelled navigation
    const target = window.location.hash.replace(/^#/, '') || '/';
    this.auth0.loginWithRedirect({ authorizationParams: { prompt: 'login' }, appState: { target } })
  }
}
